import { get, postJSON, del } from '@/utils/axios'

// 客户管理头部数据统计
export const userListStatistics = (options) => postJSON('user/userListStatistics', options)


// 客户标签统计
export const userLabelStatistics = (options) => postJSON('user/userLabelStatistics', options)

// 客户距离统计
export const homeDistanceStatistic = (options) => postJSON('user/homeDistanceStatistic', options)

// 潛在客户统计
export const potentialUserStatistics = (options) => postJSON('user/potentialUserStatistics', options)

// 客户来源
export const sourceTypeStatistics = (options) => postJSON('user/sourceTypeStatistics', options)

// 客户年龄
export const userAgeStatistic = (options) => postJSON('user/userAgeStatistic', options)

// 客户群组
export const userGroupStatistics = (options) => postJSON('user/userGroupStatistics', options)

// 保存编辑群组
export const saveGroup = (options) => postJSON('group/saveGroup',options)

// 客户管理列表
export const findUserInfoList = (options) => postJSON('user/findUserInfoList',options)

// 保存编辑标签
export const labelSaveLable = (options) => postJSON('label/saveLable',options)

// 查询全部标签
export const labelSelectList = (options) => get('label/selectList',options)

// 查询全部标签
export const labelDeleteLabel = (options) => del('label/deleteLabel',options)

// 删除客户标签
export const deleteUserLabel = (options) => del('label/deleteUserLabel',options, {}, false)

// 查询全部群组
export const groupSelectList = (options) => get('group/selectList',options)

// 删除群组
export const groupDeleteGroup = (options) => del('group/deleteGroup',options)

// 删除客户群组
export const groupDeleteUserGroup = (options) => del('group/deleteUserGroup',options, {}, false)

// 查询职位数据列表
export const findCompanyPosition = () => get('user/findCompanyPosition')

// 查询行业数据列表
export const findIndustry = () => get('user/findIndustry')

// 保存客户信息
export const saveUserInfo = (options) => postJSON('user/saveUserInfo',options)

// 手机号精确查询客户信息
export const selectByPhone = (options) => get('user/selectByPhone',options, null, false )

// 客户PK查询客户信息
export const selectByUserPk = (options) => get('user/selectByUserPk',options, null, false )

// 会员类型列表
export const vipTypeList = (options) => postJSON('vipType/list',options )

// 会员卡卡种列表
export const cardTypeCfgList = () => get('cardTypeCfg/list' )

//按客户pk查询车辆列表
export const selectUserCarByUserPk = (userPk:string) => get('car/selectUserCarByUserPk', {userPk})

//按客户pk查询客户会员卡列表
export const selectUserCardListByUserPk = (userPk:string) => get('userCard/selectUserCardListByUserPk', {userPk})

//按客户pk查询客户消费卡列表
export const userCashBackCardList = (userPk:string) => get('userCashBackCard/list', {userPk})

//查询客户服务顾问列表
export const selectUserServiceConsultantList = (userPk:string) => get('user/selectUserServiceConsultantList', {userPk})

// 查询服务顾问列表
interface GetConsultantListOptions {
    page: number // 页码
    size: number // 每页大小
}
export const getConsultantList = (options: GetConsultantListOptions) => get('/yme-system/staff/selectServiceConsultantList', options)

// 给客户分配顾问
interface UpdateCustomerConsultantOptions {
    userPk: string // 客户pk
    consultantDtos: { // 顾问列表
        type: string // 顾问类型0-销售 1-售后 2-续保 3-保险 5-技术
        sysUserPk: string // 顾问pk
    }[]
}
export const updateCustomerConsultant = (options: UpdateCustomerConsultantOptions) => postJSON('user/updateServiceConsultant', options)


//顾问人数统计
export const getAdviserCount = () => get('adviser/adviserCount')

//顾问列表
interface AdviserListProps {
    adviserType: number | string // 顾问类型0-售后 1-续保
    endTime?:string //查询结束日期
    startTime?:string //查询开始日期
}
export const getAdviserList = (options:AdviserListProps) => get('adviser/adviserList', options)

//顾问分配详情(按客户)
interface AdviserDetailProps {
    adviserPk: string // 顾问PK
    endTime?:string //查询结束日期
    startTime?:string //查询开始日期
}
export const getAdviserDetail = (options:AdviserDetailProps) => get('adviser/adviserDetail',options)

//顾问分配详情(按车辆)
interface AdviserDetailByCarProps {
    adviserPk: string // 顾问PK
    endTime?:string //查询结束日期
    startTime?:string //查询开始日期
}
export const getAdviserDetailByCar = (options:AdviserDetailByCarProps) => get('adviser/adviserDetailByCar',options)

// 客户来源
interface findAllSourceTypeOptions {
    page: number 
    size: number
}
export const findAllSourceType = (options: findAllSourceTypeOptions) => postJSON('sourceType/findAllSourceType', options)





